// src/slices/testbedSlice.js
import { createSlice } from '@reduxjs/toolkit';

const STORAGE_KEY = 'activeTestbed';
const initial = localStorage.getItem(STORAGE_KEY) || ''; // ← no default

const slice = createSlice({
  name: 'testbed',
  initialState: { active: initial },
  reducers: {
    setTestbed(state, action) {
      state.active = action.payload;
      localStorage.setItem(STORAGE_KEY, state.active);
    },
    clearTestbed(state) {                      // ← optional helper
      state.active = '';
      localStorage.removeItem(STORAGE_KEY);
    },
  },
});

export const { setTestbed, clearTestbed } = slice.actions;
export const selectTestbed = (state) => state.testbed?.active || '';
export default slice.reducer;
